module.exports = __webpack_public_path__ + "f3f9c951a569cb3d397c74a2e21fef1f.pdf";